<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-66 md-xsmall-size-100 mx-auto">
      <simple-wizard v-if="!registered" :is-modal="isModal" :is-edit="isEdit" :go-next="goNext" @close="handleClose">
        <template slot="header">
          <!-- <h3 class="title" style="line-height: 12px">
            {{ isEdit ? "Edit Patient" : "Register With GlobeChek" }}
          </h3> -->
          <h5 class="category">
            <span style="font-weight: 500; color: #1f5aff">Globe</span>
            <span style="font-weight: 700; color: #555">Chek</span>&nbsp;
            <span style="font-weight: 400; color: 222">
              {{ isEdit ? "Edit Patient Details" : "Patient Registration" }}
            </span>
            <hr style="margin-top: 20px" />
          </h5>
        </template>

        <wizard-tab :before-change="() => validateStep('step1')">
          <template slot="label">
            {{ isEdit ? "Edit Personal Details" : "Personal Details" }}
          </template>
          <first-step ref="step1" :is-edit="isEdit" @on-validated="onStepValidated" @complete="nextTab" />
        </wizard-tab>

        <wizard-tab :before-change="() => validateStep('step2')">
          <template slot="label">
            {{ isEdit ? "Edit Medical History" : "Medical History" }}
          </template>
          <second-step ref="step2" :is-edit="isEdit" @on-validated="wizardComplete" />
        </wizard-tab>
      </simple-wizard>

      <div v-if="registered">
        <div class="md-card md-card-wizard active md-theme-default">
          <div class="md-card-header">
            <!-- <h3 class="title" style="line-height: 12px">
              {{ isEdit ? "Edit Patient" : "Register With GlobeChek" }}
            </h3> -->
            <h5 class="category">
              <span style="font-weight: 500; color: #1f5aff">Globe</span>
              <span style="font-weight: 700; color: #555">Chek</span>&nbsp;
              <span style="font-weight: 400; color: 222">
                {{ isEdit ? "Edit Patient Details" : "Patient Registration" }}
              </span>
              <hr style="margin-top: 20px" />
            </h5>
          </div>
          <div style="margin-bottom: 1rem">
            <third-step ref="step3" />
            <div style="text-align: center">
              <md-button @click="goToLogin">
                {{ isEdit ? "Back to Patients Management" : "Login" }}
              </md-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loader :is-visible="isLoading" />
    <ChooseOrganizationModal v-if="isOrganizationModalOpen" :is-open="isOrganizationModalOpen"
      @cancel="closeOrganizationModal" @save="handleOrganizationSelected" />
  </div>
</template>

<script>
import FirstStep from "./Wizard/Patient_Registration/1_PersonalDetails.vue"
import SecondStep from "./Wizard/Patient_Registration/2_MedicalHistory.vue"
import ThirdStep from "./Wizard/Patient_Registration/3_Confirmation.vue"
import { SimpleWizard, WizardTab } from "@/components"
import Swal from "sweetalert2"
import { mapGetters, mapActions } from "vuex"
import loader from "@/components/GlobeChek/loader.vue"
import axios from "axios"
import ChooseOrganizationModal from "@/components/modals/ChooseOrgModal.vue"

export default {
  components: {
    FirstStep,
    SecondStep,
    ThirdStep,
    SimpleWizard,
    WizardTab,
    loader,
    ChooseOrganizationModal
  },
  data() {
    return {
      wizardModel: {},
      goNext: false,
      registered: false,
      isLoading: false,
      isOrganizationModalOpen: false,
      selectedOrganization: null
    }
  },
  props: {
    isModal: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["ptPrereg"]),
    isPhone() {
      if (window.screen.width < 760) {
        return true
      } else {
        return false
      }
    },
    screenWidth() {
      return window.screen.width
    },
    sendGlasses() {
      return this.ptPrereg.medical.correctiveLens == 'I wear Glasses'
        || this.ptPrereg.medical.correctiveLens == 'I wear Glasses and Contacts'
        || this.ptPrereg.medical.correctiveLens == 'I wear a Bifocal or Progressive'
        || this.ptPrereg.medical.correctiveLens == 'I wear OTC readers'
        || this.ptPrereg.medical.correctiveLens == 'I wear Glasses and SCL'
        || this.ptPrereg.medical.correctiveLens == 'I wear SCL'
    },
    sendContacts() {
      return this.ptPrereg.medical.correctiveLens == 'I wear Contacts'
        || this.ptPrereg.medical.correctiveLens == 'I wear Glasses and Contacts'
        || this.ptPrereg.medical.correctiveLens == 'I wear Glasses and SCL'
        || this.ptPrereg.medical.correctiveLens == 'I wear SCL'
    }
  },
  methods: {
    ...mapActions(["updatePatient"]),
    nextTab() {
      this.goNext = true
      this.$nextTick(() => {
        this.goNext = false
      })
    },

    validateStep(ref) {
      return this.$refs[ref].validate()
    },
    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model }
    },
    async wizardComplete() {
      this.isLoading = true
      try {
        if (this.isEdit) {
          this.selectedOrganization = { orgId: this.ptPrereg.editInfo.orgId }
          await this.editPatient()
        } else {
          const orgsData = sessionStorage.getItem("organizations")
          const organizations = JSON.parse(orgsData)
          if (organizations && organizations.length > 1) {
            this.isOrganizationModalOpen = true
            return
          } else if (organizations && organizations.length === 1) {
            this.selectedOrganization = [organizations[0].orgId]
            await this.registerPatient()
            this.successfulMsg()
          } else {
            let orgId = sessionStorage.getItem("userOrgID")
            if (!orgId || orgId === "null") {
              orgId = JSON.parse(localStorage.getItem("currentOrg")).id
            }

            this.selectedOrganization = [orgId];
            await this.registerPatient()
            this.successfulMsg()
          }
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.isLoading = false
      }
    },
    goToLogin() {
      if (this.isModal) {
        this.$emit("close", false)
      } else this.$router.push("/login")
    },
    definePayload() {
      const orgId = this.selectedOrganization

      const data = {
        id: this.ptPrereg.editInfo.ID,
        chiefComplaint: this.ptPrereg.medical.chiefComplaint,
        issues: this.ptPrereg.medical.issues,
        wearCorrectiveLense: this.ptPrereg.medical.correctiveLens,
        glassesHistory: this.sendGlasses ? this.ptPrereg.medical.glassesHistory : null,
        contactsHistory: this.sendContacts ? this.ptPrereg.medical.contactsHistory : null,
        height: this.ptPrereg.personal.height,
        userType: "Patient",
        patientRelationshipToInsured: this.ptPrereg.personal.patientRelationshipToInsured,
        insuranceId: this.ptPrereg.personal.insuranceId,
        insurance: this.ptPrereg.personal.insurance,
        groupNumber: this.ptPrereg.personal.groupNumber,
        referralNumber: this.ptPrereg.personal.referralNumber,
        history: {
          id: null,
          patientID: null,
          surgery: this.ptPrereg.medical.previousEyeSurgery ? Number(this.ptPrereg.medical.previousEyeSurgery) : 0,
          cancer: this.ptPrereg.medical.historyCancer ? Number(this.ptPrereg.medical.historyCancer) : 0,
          diabeties:
            this.ptPrereg.medical.historyDiabetes != "None" ? Number(this.ptPrereg.medical.historyDiabetes) : 0,
          others: this.ptPrereg.personalHistory.other || "",
          cholestrol: String(this.ptPrereg.personalHistory.highCholesterol),
          heart: String(this.ptPrereg.personalHistory.heartDisease),
          liver: String(this.ptPrereg.personalHistory.liverDisease),
          migranes: String(this.ptPrereg.personalHistory.migraines),
          pressure: String(this.ptPrereg.personalHistory.highBloodPressure),
          stroke: String(this.ptPrereg.personalHistory.stroke)
        },
        familyHistory: {
          id: null,
          patientID: this.ptPrereg.editInfo.ID,
          alzheimers: String(this.ptPrereg.familyHistory.alzheimers),
          cancer: String(this.ptPrereg.familyHistory.cancer),
          cholesterol: String(this.ptPrereg.familyHistory.highCholesterol),
          diabetes: String(this.ptPrereg.familyHistory.diabetes),
          glaucoma: String(this.ptPrereg.familyHistory.glaucoma),
          heart: String(this.ptPrereg.familyHistory.heartDisease),
          liver: String(this.ptPrereg.familyHistory.liverDisease),
          macDegen: String(this.ptPrereg.familyHistory.macularDegeneration),
          migraines: String(this.ptPrereg.familyHistory.migraines),
          pressure: String(this.ptPrereg.familyHistory.highBloodPressure),
          stroke: String(this.ptPrereg.familyHistory.stroke),
          other: this.ptPrereg.familyHistory.other || ""
        },
        address: {
          id: this.ptPrereg.personal.id,
          address1: this.ptPrereg.personal.address_L1,
          address2: this.ptPrereg.personal.address_L2,
          city: this.ptPrereg.personal.city,
          state: +this.ptPrereg.personal.state,
          country: this.ptPrereg.personal.country.toString(),
          zipCode: this.ptPrereg.personal.zip
        },
        insuredAddress: this.ptPrereg.personal.patientRelationshipToInsured === 'Self' ? null : {
          id: this.ptPrereg.editInfo.insuredAddressID,
          address1: this.ptPrereg.personal.insuredAddress,
          address2: null,
          city: this.ptPrereg.personal.insuredCity,
          state: String(this.ptPrereg.personal.insuredState),
          country: this.ptPrereg.personal.insuredCountry.toString(),
          zipCode: this.ptPrereg.personal.insuredZip
        },
        person: {
          id: this.ptPrereg.editInfo.personID,
          firstName: this.ptPrereg.personal.firstName,
          lastName: this.ptPrereg.personal.lastName,
          title: "",
          email: this.ptPrereg.personal.email,
          cellNumber: this.ptPrereg.personal.cellPhone,
          allowSMS: this.ptPrereg.personal.allowSMS || false,
          gender: this.ptPrereg.personal.gender ? this.ptPrereg.personal.gender.toLowerCase() : "",
          DOB: new Date(this.ptPrereg.personal.DOB).toISOString().slice(0, 19).replace("T", " "),
          comments: "",
          languages: null,
          dob: new Date(this.ptPrereg.personal.DOB).toISOString().slice(0, 19).replace("T", " ")
        },
        insuredPerson: this.ptPrereg.personal.patientRelationshipToInsured === 'Self' ? null : {
          id: this.ptPrereg.editInfo.insuredPersonID,
          firstName: this.ptPrereg.personal.insuredFirstName,
          lastName: this.ptPrereg.personal.insuredLastName,
          title: '',
          email: '',
          cellNumber: '',
          allowSMS: false,
          gender: this.ptPrereg.personal.insuredGender ? this.ptPrereg.personal.insuredGender.toLowerCase() : "",
          DOB: this.ptPrereg.personal.insuredDOB ? new Date(this.ptPrereg.personal.insuredDOB).toISOString().slice(0, 19).replace("T", " ") : null,
          comments: "",
          languages: null,
          dob: this.ptPrereg.personal.insuredDOB ? new Date(this.ptPrereg.personal.insuredDOB).toISOString().slice(0, 19).replace("T", " ") : null
        },
        height1: this.ptPrereg.personal.height.split("'")[0] || "",
        height2: this.ptPrereg.personal.height.split("'")[1] || "",
        orgID: orgId[0],
        organisations: Array.isArray(orgId) ? orgId.map(i => i.orgId || i) : [orgId && orgId.orgId ? orgId.orgId : orgId]
      }
      return data
    },

    async registerPatient() {
      // alert(" * * * Registering Patient * * * ")
      var vm = this
      const userId = sessionStorage.getItem("userID")
      const config = { headers: { "Content-Type": "application/json" } }
      const url = !userId
        ? process.env.VUE_APP_URL + "/patient/registration"
        : `${process.env.VUE_APP_URL}/patient/admin/registration/${userId}`
      const data = this.definePayload()
      await window.axios
        .post(url, data, config)
        .then(function (response) { })
        .catch(function (error) {
          vm.status = "An error occurred: " + error
          console.log(error)
          if (error.response && error.response.status === 400 && error.response.data.detail.message) {
            Swal.fire({
              title: "Error",
              text: error.response.data.detail.message,
              icon: "error",
              confirmButtonText: "OK"
            })
            throw new Error(error.response.data.detail.message)
          }

          alert("Server Error. Please re-submit")
          throw new Error(error)
        })
    },
    async editPatient() {
      let payload = this.definePayload()
      payload.address.state = this.ptPrereg.personal.state.toString()
      payload.address.country = this.ptPrereg.personal.country.toString()
      const patientId = this.ptPrereg.editInfo.ID
      try {
        await this.updatePatient({ patientId, payload })
        Swal.fire({
          title: "Patient Updated",
          text: "Patient has been updated successfully",
          icon: "success",
          confirmButtonText: "OK"
        }).then(() => {
          this.$emit("close", true)
        })
      } catch (e) {
        console.log(e)
        const errorMsg = e.message || `An error occurred while updating the patient.`
        Swal.fire({
          title: "Error",
          text: errorMsg,
          icon: "error",
          confirmButtonText: "OK"
        })
      }
    },
    handleClose() {
      this.$emit("close", false)
    },
    closeOrganizationModal() {
      this.isOrganizationModalOpen = false
    },
    async handleOrganizationSelected(organization) {
      this.selectedOrganization = organization
      this.isOrganizationModalOpen = false
      await this.registerPatient()
      this.successfulMsg()
    },
    successfulMsg() {
      if (!this.isModal) {
        this.registered = true
      }
      if (this.isModal) {
        Swal.fire({
          title: "Registration Successful",
          text: "Patient has been registered successfully",
          icon: "success",
          confirmButtonText: "OK"
        }).then(() => {
          this.$emit("close", true)
        })
      }
    }
  }
}
</script>
